export enum NOTIFY_STATUSES {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    DEFAULT = 'DEFAULT',
}
